import { render, staticRenderFns } from "./p-my-pills-list.vue?vue&type=template&id=c3f5d1aa&scoped=true"
import script from "./p-my-pills-list.vue?vue&type=script&lang=js"
export * from "./p-my-pills-list.vue?vue&type=script&lang=js"
import style0 from "./p-my-pills-list.vue?vue&type=style&index=0&id=c3f5d1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f5d1aa",
  null
  
)

export default component.exports